import i18next from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpApi from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

import enTranslation from "../locales/en/translation.json";
import deTranslation from "../locales/de/translation.json";

export const supportedLngs: { [key: string]: { name: string; locale: string } } = {
  de: {
    name: "Deutsch",
    locale: "de-DE",
  },
  en: {
    name: "English",
    locale: "en-US",
  }
};

i18next
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    resources: {
      de: { translation: deTranslation },
      en: { translation: enTranslation },
    },
    fallbackLng: "de",
    supportedLngs: Object.keys(supportedLngs),
    detection: {
      order: ["navigator", "localStorage", "cookie"],
      caches: ["localStorage", "cookie"],
      lookupLocalStorage: "i18nextLng",
      lookupCookie: "i18next",
    },
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  });

export default i18next;
